import React, {useMemo} from 'react';

const colors = ['#69D994', '#9DDEAD', '#B3E5C2', '#E5F6EB'];
const circlesCount = 40;

const randRange = (min: number, max: number) => (
	Math.random() * (max - min) + min
);

const useCircles = () => (
	useMemo(() => {
		const generated: JSX.Element[] = [];
		for (let index = 0; index < circlesCount; index++) {
			const size = randRange(2, 4);
			const colorIndex = index % colors.length;
			const duration = randRange(5, 8);
			const delay = randRange(-5, 0); // Negative delay for immediate start at different positions
			const growth = randRange(0.5, 1.5);
			const centerX = randRange(25, 75);
			const centerY = randRange(0, 100);

			generated.push(
				<circle
					key={`pulse-${index}`}
					cx={centerX}
					cy={centerY}
					r={size}
					fill={colors[colorIndex]}
					opacity='0.7'
				>
					<animate
						attributeName='r'
						values={`${size};${size * growth};${size}`}
						dur={`${duration}s`}
						begin={`${delay}s`}
						repeatCount='indefinite'
						calcMode='spline'
						keySplines='0.5 0 0.5 1; 0.5 0 0.5 1'
					/>
					<animate
						attributeName='opacity'
						values='0.7;0.4;0.7'
						dur={`${duration}s`}
						begin={`${delay}s`}
						repeatCount='indefinite'
						calcMode='spline'
						keySplines='0.5 0 0.5 1; 0.5 0 0.5 1'
					/>
				</circle>
			);
		}
		return generated;
	}, [])
);

export const SlowPulse = () => {
	const circles = useCircles();
	return (
		<div>
			<svg
				width='100%'
				height='100%'
				viewBox='0 0 100 100'
				preserveAspectRatio='none'
			>
				{circles}
			</svg>
		</div>
	);
};
